<template>
  <div>
    <ld-header
      @click-left="back"
    >
      支付成功
    </ld-header>
    <div class="pad-6">
      <van-cell class="b-r-4">
        <van-row>
          <van-col span="17">
            <div class="font24 font-lg pad-6">
              支付成功
            </div>
            <p class="font12 pad-6">
              点击'查看订单'可查看此订单详情
            </p>
            <div class="pad-6 half-width">
              <ld-button
                size="md"
                defaults
                round
                @click="toDetail"
              >
                {{ $t('B011','查看订单') }}
              </ld-button>
            </div>
          </van-col>
          <van-col span="7">
            <img
              class="full-width"
              src="~Assets/images/pay/paySuccess.png"
            >
          </van-col>
        </van-row>
      </van-cell>
      <div class="pad-b-5" />
      <ld-button
        detault
        to="/home"
      >
        {{ $t('B012','继续预订') }}
      </ld-button>
    </div>
  </div>
</template>

<script>
import {Cell} from 'vant'
import ldButton from 'Common/ldButton'
import Bussiness from 'Utils/business'

export default {
  name:'PaySuccess',
  components: {
    [Cell.name]:Cell,
    ldButton
  },
  data(){
    return {
      orderList:[]
    }
  },
  computed:{
    orderType(){
      return this.$route.query.orderType
    },
    orderId(){
      return this.$route.query.orderId
    },
    out_trade_no(){
      return this.$route.query.out_trade_no
    }
  },
  updated() {
    this.zhif();
  },
  created(){
    this.zhif();
  },
  mounted(){
    if(this.out_trade_no){
      this.showOrderDetail(this.out_trade_no)
    }
  },
  methods:{
    zhif(){
      this.$api['tkOrder/orderDetail']({
        id:this.orderId
      }).then(res => {
        if(res.data.orderStatus =='10'){
          var st = JSON.parse(sessionStorage.getItem('objp'))
          this.$router.push({
            path:'/tk/tkCmplc',
            query:{
              orderType:'11001',
              orderId:st.orderList[1].orderId,
              second:'2'
            }
          })
        }else{
          var st = JSON.parse(sessionStorage.getItem('objp'))
          this.$router.push({
            path:'/tk/tkCmplc',
            query:{
              orderType:'11001',
              orderId:st.orderList[1].orderId,
              second:'2'
            }
          })
        }
      })
    },
    toDetail(){
      if(this.orderList.length>0){
        var order = this.orderList[0]
        Bussiness.toOrderDetail({id:order.orderId,orderType:order.orderType})
      }else{
        Bussiness.toOrderDetail({id:this.orderId,orderType:this.orderType})
      }
    },
    showOrderDetail(payInfoId){
      this.$api['common/getPayOrderIdList']({
        payInfoId:payInfoId
      }).then(resp=>{
        this.orderList=resp.data||[]
      })
    },
    back(){
      this.$router.push({path:'/allOrder'})
    }
  },
  filters:{
  }
}
</script>

<style  lang="less" scoped>
.pad-6{
    padding: 6px;
}
.pad-b-5{
    padding-bottom: 5px;
}
.b-r-4{
    border-radius: 4px;
}
.half-width{
    width: 50%;
}
</style>
